//引入
import request from "../utils/request";
import wyqyId from "../config";
const api = {
  //统计
  bxjssctj: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwybsbx/bxjssctj",
    });
  },

  //楼栋分布
  bxldfb: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/yzsxldfb",
    });
  },

  //楼栋分布
  fzqk: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/yzsxpffb",
    });
  },

  //评价分值情况
  lyqk: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/yzsxlyfb",
    });
  },

  //进六月
  bxqs: function () {
    let params = {
      wyqyId: wyqyId,
    };
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/yzsxsixqs",
    });
  },

  //报事报修记录
  fwtzlist: function (params) {
    return request({
      method: "get",
      params,
      // url: "middlescreen/api/zhwybsbx/fwtzlist",
      url: "middlescreen/api/zhwybsbx/bsbxlist",
    });
  },

  // 报修详情
  fwtzlist: function (params) {
    return request({
      method: "get",
      params,
      // url: "middlescreen/api/zhwybsbx/fwtzlist",
      url: "middlescreen/api/zhwybsbx/bsbxlist",
    });
  },

  // 报修详情
  bxInfo: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwybsbx/getBsBx",
    })
  },




  //投诉列表
  tslist: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwybsbx/tslist",
    });
  },

  //投诉列表
  tslistNew: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/selectyzsxList",
    });
  },




  // new 
  tsInfo: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwybsbx/getTs",
    });
  },

  tsInfoNew: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwyyzsx/selectyzsxDetail",
    });
  },

      //获取受理员工列表
    getSlyg: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwyyzsx/selectslr",
        });
    },

  //报事报修详情 
  bsbxinfo: function (params) {
    return request({
      method: "get",
      params,
      url: `middlescreen/api/zhwybsbx/bsbxinfo`,
      params
    });
  },

  // 获取报事报修指南 、 报事报修&投诉流程
  getInfo: function (params) {
    return request({
      method: "get",
      params,
      url: "middlescreen/api/zhwygkgs/getInfo",
    });
  },
};

export default api;
